// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"b5dc9d8c","23":"43f7088c","29":"d8836ae0","252":"da30835d","316":"a12165e2","781":"8f15fbc3","787":"c4e7f8f9","970":"21ed9fe8"}[chunkId] + ".chunk.js";
};